import Module from '@/classes/modules/Module'

export default class Modules extends Array {
  constructor (modules, ...rest) {
    Array.isArray(modules) ? super(...modules.map(module => new Module(module)).filter(module => module.is_visible)) : super(...rest)
  }

  get attributes () {
    return this.reduce((attrs, module) => ({ ...attrs, [module.custom_key]: module.attributes }), {})
  }

  get custom_path () {
    return this.map(module => module.path).find(path => path)
  }
}
